import { ToggleButtonGroup, ToggleButton } from '@mui/material'

import { PERIOD_OPTIONS, type Period } from '@/utils/dates'

interface DateRangePickerProps {
    value: Period
    onChange: (period: Period) => void
}

export function DateRangePicker({ value, onChange }: DateRangePickerProps) {
    return (
        <ToggleButtonGroup
            value={value}
            exclusive
            onChange={(_, v) => v && onChange(v as Period)}
            size="small"
        >
            {PERIOD_OPTIONS.map(opt => (
                <ToggleButton
                    key={opt.value}
                    value={opt.value}
                    sx={{ textTransform: 'none', px: 1.5 }}
                >
                    {opt.label}
                </ToggleButton>
            ))}
        </ToggleButtonGroup>
    )
}
